import loadable from '@loadable/component'

export const Issues = loadable(() => import('./Issues'))
export const IssueLevel2 = loadable(() => import('./IssueLevel2'))
export const IssueLevel1 = loadable(() => import('./IssueLevel1'))
export { default as issuesMocks } from './__mocks__/Issues.mock'
export type { IssueProps, IssuesProps } from './Issues'
export type { IssueLevel1Props } from './IssueLevel1'
export type { BondProps } from './IssueLevel2'
